/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_1_P1Inputs */

const en_terms_section_1_p1 = /** @type {(inputs: Terms_Section_1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By accessing and using the Lindevo website (lindevo.com) and our services, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use our website or services.`)
};

const lv_terms_section_1_p1 = /** @type {(inputs: Terms_Section_1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piekļūstot un izmantojot Lindevo mājaslapu (lindevo.com) un mūsu pakalpojumus, Jūs piekrītat būt saistītam ar šiem Lietošanas noteikumiem. Ja Jūs nepiekrītat kādam šo noteikumu punktam, lūdzu neizmantojiet mūsu mājaslapu vai pakalpojumus.`)
};

/**
* | output |
* | --- |
* | "By accessing and using the Lindevo website (lindevo.com) and our services, you agree to be bound by these Terms of Service. If you do not agree with any part..." |
*
* @param {Terms_Section_1_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_1_p1 = /** @type {((inputs?: Terms_Section_1_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_1_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_1_p1(inputs)
	return en_terms_section_1_p1(inputs)
});